import './Button.css'

const VARIANT_CLASS = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  danger: 'btn-danger',
  success: 'btn-success',
  text: 'btn-text',
}

export default function Button({
  variant = 'primary',
  size,
  icon: Icon,
  children,
  className = '',
  ...props
}) {
  const cls = [
    VARIANT_CLASS[variant] || VARIANT_CLASS.primary,
    size === 'small' ? 'btn-small' : '',
    className,
  ].filter(Boolean).join(' ')

  return (
    <button type="button" className={cls} {...props}>
      {Icon && <Icon className="btn-icon" />}
      {children}
    </button>
  )
}
